import {
    DEALERREQWITHDRAWEMONEY_SUCCESS,
    DEALERREQWITHDRAWEMONEY_FAILED,
    RESET_DEALERREQWITHDRAWEMONEY,
    LOADING_DEALERREQWITHDRAWEMONEY,
    NETWORK_ERROR_DEALERREQWITHDRAWEMONEY
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerReqWithdrawEMoney = () => {
    return { type: RESET_DEALERREQWITHDRAWEMONEY };
};

const dealerReqWithdrawEMoney = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERREQWITHDRAWEMONEY });
    await dealerServices
        .post("requestWithDrawEmoney", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerReqWithdrawEMoneysuccess(res.data));
                    break;
                default:
                    dispatch(dealerReqWithdrawEMoneyFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERREQWITHDRAWEMONEY,
                payload: err
            });
        });
};
function dealerReqWithdrawEMoneysuccess(data) {
    return {
        type: DEALERREQWITHDRAWEMONEY_SUCCESS,
        payload: data
    };
}
function dealerReqWithdrawEMoneyFailed(data) {
    return {
        type: DEALERREQWITHDRAWEMONEY_FAILED,
        payload: data
    };
}

export { resetDealerReqWithdrawEMoney, dealerReqWithdrawEMoney };
